<template>
    <div class="account-member">
        <div class="open-wrapper pointer" @click="openModal">
            <slot>
                <a href="javascript://void(0)">Open</a>
            </slot>
        </div>

        <modal :name=modalId
               :adaptive="true"
               :scrollable="true"
               height="auto">
            <div class="dashboard-block" :class="{loading: loading}">
                <header>
                    <h4 v-if="model.accountable" class="display-block">
                        <span v-if="model.accountable_type === 'App\\User'">{{model.accountable.first_name}} {{model.accountable.last_name}}</span>
                        <span v-else>Lease</span>

                        <span v-if="model.archivedLabel" v-html="model.archivedLabel"></span>
                    </h4>
                    <h4 v-else>Add Account Member</h4>

                    <h5 v-if="model.created_at">Account Member</h5>

                    <a href="javascript://void(0)" class="back" @click="closeModal">Close</a>
                </header>

                <div>
                    <dl v-if="model.created_at && model.accountable_type === 'App\\Lease'">
                        <dt>Lease</dt>
                        <dd>
                            <ul class="list-unstyled">
                                <li v-for="resident in model.accountable.residents" :key="resident.id">
                                    <a :href="'/residents/' + resident.id">{{resident.first_name}} {{resident.last_name}}</a>
                                </li>
                            </ul>
                        </dd>
                    </dl>

                    <dl v-else-if="model.created_at && model.accountable_type === 'App\\User' && model.accountable">
                        <dt>User</dt>
                        <dd>
                            <a :href="'/users/' + model.accountable_id">{{model.accountable.fullName}}</a>
                        </dd>
                    </dl>

                    <form @submit.prevent="saveModel" accept-charset="UTF-8" novalidate="novalidate"
                          data-vv-scope="accountMember">
                        <fieldset>
                            <legend>Account Member</legend>

                            <div class="form-group has-feedback"
                                 v-if="!model.created_at && !leaseAccountMember"
                                 :class="{'has-error': errors.has('accountMember.AccountMember[accountable_type]')}">
                                <label>&nbsp;</label>

                                <div class="btn-group btn-group-justified" role="group">
                                    <div class="btn-group" role="group">
                                        <button type="button"
                                                :class="{ active: model.accountable_type === 'App\\Lease' }"
                                                class="btn btn-sm btn-success"
                                                @click="model.accountable_type = 'App\\Lease'">
                                            Lease
                                        </button>
                                    </div>
                                    <div class="btn-group" role="group">
                                        <button type="button"
                                                :class="{ active: model.accountable_type === 'App\\User' }"
                                                class="btn btn-sm btn-primary"
                                                @click="model.accountable_type = 'App\\User'">
                                            User
                                        </button>
                                    </div>
                                </div>

                                <span v-show="errors.has('accountMember.AccountMember[accountable_type]')"
                                      class="help-block">
                                    {{ errors.first('accountMember.AccountMember[accountable_type]') }}
                                </span>
                            </div>

                            <div class="form-group has-feedback"
                                 v-if="!model.created_at"
                                 :class="{'has-error': errors.has('accountMember.AccountMember[accountable_id]')}">
                                <auto-complete
                                    @change="setAccountable"
                                    class="form-group"
                                    name="AccountMember[accountable_id]"
                                    label="Lease"
                                    v-show="!leaseAccountMember && model.accountable_type === 'App\\Lease'"
                                    :initialId="model.accountable_id"
                                    :query-string="'status=unenrolled&limit=10&project_id=' + projectId"
                                    search-results-index="Residents"
                                    find-result-index="Resident"
                                    resource-url="/api/residents"
                                    ref="userAutoComplete">
                                    <template slot-scope="resident" slot="model-display">
                                        {{resident.first_name}} {{resident.last_name}} (Apt: {{resident.lease.unit}})
                                    </template>
                                </auto-complete>

                                <auto-complete
                                    @change="setAccountable"
                                    class="form-group"
                                    name="AccountMember[accountable_id]"
                                    label="User"
                                    v-show="model.accountable_type === 'App\\User'"
                                    :initialId="model.accountable_id"
                                    :query-string="'limit=10&project_id=' + projectId"
                                    search-results-index="Users"
                                    find-result-index="User"
                                    resource-url="/api/users"
                                    ref="userAutoComplete">
                                    <template slot-scope="user" slot="model-display">
                                        {{user.first_name}} {{user.last_name}} ({{user.email}})
                                    </template>
                                </auto-complete>

                                <input type="hidden"
                                       name="AccountMember[accountable_id]"
                                       v-validate="'required'"
                                       v-model="model.accountable_id">

                                <span v-show="errors.has('accountMember.AccountMember[accountable_id]')"
                                      class="help-block">
                                    {{ errors.first('accountMember.AccountMember[accountable_id]') }}
                                </span>
                            </div>

                            <hr v-if="!model.created_at && !model.deleted_at">

                            <div class="row">
                                <div class="col-xs-6">
                                    <button type="button" class="btn btn-sm btn-warning"
                                            @click="() => isMultiSignature ? null : deleteModel()"
                                            v-if="model.created_at && !model.deleted_at"
                                            :disabled="isMultiSignature || loading">
                                        <i class="fa fa-trash" aria-hidden="true"></i>
                                    </button>

                                    <button type="button" class="btn btn-sm btn-warning"
                                            @click="() => isMultiSignature ? null : restoreModel()"
                                            v-if="model.created_at && model.deleted_at"
                                            :disabled="isMultiSignature || loading">
                                        <i class="fa fa-refresh" aria-hidden="true"></i>
                                    </button>
                                </div>

                                <div class="col-xs-6 form-group pull-right"
                                     v-if="!model.created_at && !model.deleted_at">
                                    <button type="submit" class="btn btn-success btn-block" :disabled="isMultiSignature || loading">
                                        Save
                                    </button>
                                </div>
                            </div>
                        </fieldset>
                    </form>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
    import model from "./mixins/model";

    export default {
        mixins: [ model ],

        props: {
            account: {
                required: true,
                type: Object
            },

            accountId: {
                required: true,
                type: String
            },

            accountableId: {
                type: String,
                required: true
            },

            accountableType: {
                type: String,
                required: true
            },

            projectId: {
                type: String,
                required: true
            },

            isMultiSignature: {
                type: Boolean,
                required: true
            }
        },

        computed: {
            leaseAccountMember(){
                if( this.account ){
                    return _.find( this.account.accountMembers, { accountable_type: 'App\\Lease' } );
                }
            },

            saveValidationKey(){
                return 'accountMember'
            },

            resourceKey(){
                return 'AccountMember';
            },

            url(){
                if( this.model.id ){
                    return '/api/accountMembers/' + this.model.id;
                }
                else {
                    return '/api/accountMembers';
                }
            },
        },

        methods: {
            // Overrides
            beforeSave(){
                this.model.account_id = this.accountId;
            },

            getModelData(){
                return {
                    model: {
                        accountable_type: 'App\\User'
                    },
                };
            },

            setAccountable( model_id, model ){
                if( this.model.accountable_type === 'App\\Lease' ){
                    this.$set( this.model, 'accountable_id', model.lease_id );
                }
                else if( this.model.accountable_type === 'App\\User' ){
                    this.$set( this.model, 'accountable_id', model_id );
                }
            }
        }
    }
</script>
